import Stack from "@mui/material/Stack";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useLocation, useNavigate } from "react-router-dom";
import { PageHeader } from "../../components/primitives/layout/PageHeader";
import { gaps } from "../../components/primitives/spacing";
import { useUserContext } from "../../context/UserContext";
import { hasRole } from "../../lib/auth";
import { ROUTES } from "../../route_paths";

const TRACE_TABS = [
  { to: ROUTES.internal.investigations.claimTrace.path(), label: "Claim verification" },
  { to: ROUTES.internal.investigations.documentTrace.path(), label: "Document trace" },
] as const;

/** Scanning the corpus and acting on the result are admin-only, so only admins get this tab. */
const CORPUS_SCAN_TAB = {
  to: ROUTES.internal.investigations.corpusScan.path(),
  label: "Corpus scan",
} as const;

/** Heading and sub-nav shared by every /internal/investigations/* page — Investigations is a
 *  growing set of debug/observability lookups (see design-documents/021), not a single tool. */
export function InvestigationsHeader() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { session } = useUserContext();
  const tabs = hasRole(session?.user, "platform.admin")
    ? [...TRACE_TABS, CORPUS_SCAN_TAB]
    : TRACE_TABS;
  // A page below a tab (a trace of one document) keeps its tab selected.
  const current =
    tabs.find((tab) => pathname === tab.to || pathname.startsWith(`${tab.to}/`))?.to ?? tabs[0].to;

  return (
    <Stack gap={gaps.base}>
      <PageHeader
        title="Investigations"
        subtitle="Look up how the platform reached a result: a claim's verdict trace, how a document was extracted and admitted, or what a scan of the whole corpus finds missing."
      />
      <Tabs
        value={current}
        onChange={(_e, value: string) => navigate(value)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        {tabs.map((tab) => (
          <Tab key={tab.to} value={tab.to} label={tab.label} />
        ))}
      </Tabs>
    </Stack>
  );
}
